import { render, staticRenderFns } from "./PemakaianKlaimCCPp.vue?vue&type=template&id=df465156&"
import script from "./PemakaianKlaimCCPp.vue?vue&type=script&lang=js&"
export * from "./PemakaianKlaimCCPp.vue?vue&type=script&lang=js&"
import style0 from "./PemakaianKlaimCCPp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports